// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__2W2o8"};